import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { DropdownTrigger } from 'react-simple-dropdown';
import Tooltip from '@omilia/tooltip';

import useDropdown from 'utils/hooks/useDropdown';

import {
  StyledHeaderMenuItemIcon,
  StyledHeaderMenuItemLabel,
  StyledMenuItem,
  StyledDropdownContentHeader,
  StyledDropdownContentBody,
  StyledDropdownContentHeaderTitle,
} from 'components/HeaderDropdownMenu/styled';

import {
  StyledDropdown,
  StyledDropdownContent,
  StyledHeaderIcon,
} from './styled';

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line no-unused-vars

export const EXPORT_TYPES_CONFIG = {
  nlu: { level: 'nlu' },
  deployment: { level: 'app' },
  backup: { level: 'full' },
};

export const EXPORT_TYPES = {
  nlu: 'nlu',
  deployment: 'deployment',
  backup: 'backup',
};

const ExportMenu = ({ isExporting, onExport }) => {
  const dropdownRef = useRef(null);
  const { hide: hideDropdown } = useDropdown(dropdownRef);

  const handleExport = exportType => {
    hideDropdown();
    onExport(EXPORT_TYPES_CONFIG[exportType]);
  };

  return (
    <StyledDropdown ref={dropdownRef}>
      <DropdownTrigger>
        <Tooltip content="Export options" placement="left">
          <StyledHeaderIcon
            className="icon-upload"
            data-test="export-options-menu-trigger"
          />
        </Tooltip>
      </DropdownTrigger>

      <StyledDropdownContent>
        <StyledDropdownContentHeader>
          <StyledDropdownContentHeaderTitle>
            Export options
          </StyledDropdownContentHeaderTitle>
        </StyledDropdownContentHeader>

        <StyledDropdownContentBody>
          <Tooltip content="Export NLU resources only" placement="left">
            <StyledMenuItem
              as="a"
              data-test="nlu-export"
              disabled={isExporting}
              onClick={() => handleExport(EXPORT_TYPES.nlu)}
            >
              <StyledHeaderMenuItemIcon className="icon-nlu-export" />
              <StyledHeaderMenuItemLabel>NLU Export</StyledHeaderMenuItemLabel>
            </StyledMenuItem>
          </Tooltip>

          <Tooltip
            content="Export your work and deploy it in your runtime environment"
            placement="left"
          >
            <StyledMenuItem
              as="a"
              data-test="deployment-export"
              disabled={isExporting}
              onClick={() => handleExport(EXPORT_TYPES.deployment)}
            >
              <StyledHeaderMenuItemIcon className="icon-deployment-export" />
              <StyledHeaderMenuItemLabel>
                Deployment Export
              </StyledHeaderMenuItemLabel>
            </StyledMenuItem>
          </Tooltip>

          <Tooltip content="Full export your project" placement="left">
            <StyledMenuItem
              as="a"
              data-test="backup-export"
              disabled={isExporting}
              onClick={() => handleExport(EXPORT_TYPES.backup)}
            >
              <StyledHeaderMenuItemIcon className="icon-backup-save" />
              <StyledHeaderMenuItemLabel>Full Export</StyledHeaderMenuItemLabel>
            </StyledMenuItem>
          </Tooltip>
        </StyledDropdownContentBody>
      </StyledDropdownContent>
    </StyledDropdown>
  );
};

ExportMenu.propTypes = {
  isExporting: PropTypes.bool.isRequired,
  onExport: PropTypes.func.isRequired,
};

export default ExportMenu;
